import { RpcService } from 'rpc';
export const svc = new RpcService({
    transport: 'WEBSOCKET',
    envelope: 'JSON-RPC-2.0',
    strictParameters: false,
    target: `${window.hcstatic.portal_url}/@@user-info.rpc`,
    services: {
        roles: {
            cacheable: true,
            cacheLifetime: 24,
            parameters: []
        }
    }
});
export default svc;
